import { EventListeners, MinzeElement, Reactive } from 'minze'
import { config, Font } from '../../../constants'
import { Locale } from '../../../modules/locale'
import MainModule from '../../../modules/main'
import { unescapeHtml } from '../../../modules/utils'

Locale.getInstance().registerKeySet('fr', 'partnerProfile', {
  description: 'Ceci est votre profil partenaire. Vous pouvez le modifier à tout moment.',
  organizationName: "Nom de l'organisation*",
  organizationNamePlaceholder: "Nom de l'organisation",
  phone: 'No de téléphone',
  phonePlaceholder: '514 123-4567',
  role: "Fonction au sein de l'organisation*",
  rolePlaceholder: 'Fonction ou rôle',
  organizationRegionLabel: 'Région*',
  organizationRegionSearch: 'Recherchez une région',
  organizationRegionTitle: 'Sélectionnez des options',
  ticketingServiceLabel: 'Services de billeterie*',
  ticketingServiceSearch: 'Recherchez un service de billetterie',
  ticketingServiceTitle: 'Sélectionnez des options',
  organizationAddressTitle: "Adresse complète de l'organisation",
  generalInfoTitle: 'Informations générales',
  organizationProfileTitle: 'Profil de votre organisation',
  address1: 'Adresse 1*',
  address1Placeholder: 'Numéro et rue',
  address2: 'Adresse 2',
  address2Placeholder: 'Appartement, suite, etc.',
  city: 'Ville*',
  cityPlaceholder: 'Ville',
  province: 'Province*',
  provincePlaceholder: 'Province',
  postalCode: 'Code postal*',
  postalCodePlaceholder: 'Code postal',
  website: 'Site web',
  websitePlaceholder: 'https://www.example.com',
  timezones: 'Fuseau horaire*',
  culturalOrganizationType: "Type d'organisation culturelle*",
  disciplines: 'Disciplines*',
  save: 'Sauvegarder',
  errors: {
    organization: 'Veuillez entrer le nom de votre organisation',
    phone: 'Veuillez entrer votre numéro de téléphone',
    role: 'Veuillez entrer votre rôle ou fonction',
    regions: 'Veuillez sélectionner une région',
    ticketingServices: 'Veuillez sélectionner un service de billetterie',
    address1: 'Veuillez entrer votre adresse',
    city: 'Veuillez entrer votre ville',
    province: 'Veuillez entrer votre province',
    postalCode: 'Veuillez entrer votre code postal',
    timezones: 'Veuillez sélectionner un fuseau horaire',
    culturalOrgTypes: "Veuillez sélectionner un type d'organisation culturelle",
    disciplines: 'Veuillez sélectionner une discipline',
    confirmPolicy: "Veuillez accepter les conditions d'utilisation de l'espace partenaire",
    confirmTerms: "Veuillez accepter les conditions d'utilisation de l'espace partenaire",
  },
  successMessage: 'Vos informations ont été sauvegardées avec succès',
  errorMessage: 'Une erreur est survenue, veuillez réessayer plus tard',
})

Locale.getInstance().registerKeySet('en', 'partnerProfile', {
  description: 'This is your partner profile. You can modify it at any time.',
  organizationName: 'Name of the organization*',
  organizationNamePlaceholder: 'Name of the organization',
  phone: 'Telephone number',
  phonePlaceholder: '514 123-4567',
  role: 'Role within the organization*',
  rolePlaceholder: 'Role or function',
  organizationRegionLabel: 'Region*',
  organizationRegionSearch: 'Search for a region',
  organizationRegionTitle: 'Select options',
  ticketingServiceLabel: 'Ticketing services*',
  ticketingServiceSearch: 'Search for a ticketing service',
  ticketingServiceTitle: 'Select options',
  organizationAddressTitle: 'Full organization address',
  generalInfoTitle: 'General information',
  organizationProfileTitle: 'Your organization profile',
  address1: 'Address 1*',
  address1Placeholder: 'Number and street',
  address2: 'Address 2',
  address2Placeholder: 'Apartment, suite, etc.',
  city: 'City*',
  cityPlaceholder: 'City',
  province: 'Province*',
  provincePlaceholder: 'Province',
  postalCode: 'Postal code*',
  postalCodePlaceholder: 'Postal code',
  website: 'Website',
  websitePlaceholder: 'https://www.example.com',
  timezones: 'Timezone*',
  culturalOrganizationType: 'Cultural organization type*',
  disciplines: 'Disciplines*',
  save: 'Save',
  errors: {
    organizationName: 'Please enter your organization name',
    phone: 'Please enter your phone number',
    role: 'Please enter your role or function',
    regions: 'Please select a region',
    ticketingServices: 'Please select a ticketing service',
    address1: 'Please enter your address',
    city: 'Please enter your city',
    province: 'Please enter your province',
    postalCode: 'Please enter your postal code',
    timezones: 'Please select a timezone',
    culturalOrgTypes: 'Please select a cultural organization type',
    disciplines: 'Please select a discipline',
    confirmPolicy: 'Please accept the terms of use of the partner space',
    confirmTerms: 'Please accept the terms and conditions of the partner space',
  },
  successMessage: 'Your information has been successfully saved',
  errorMessage: 'An error occurred, please try again later',
})

export interface LvcPartnerProfileModalContent {
  organizationName: string
  role: string
  phone: string
  phoneExtension: string
  address1: string
  address2: string
  city: string
  province: string
  postalCode: string
  website: string
  timezones: any
  culturalOrgTypes: any
  disciplines: any
  regions: any
  ticketingServices: any
}

type PartnerData = {
  organizationName: string
  role: string
  phone: string
  phoneExtension: string
  address1: string
  address2: string
  city: string
  province: string
  postalCode: string
  website: string
  timezones: any[]
  culturalOrgTypes: any[]
  disciplines: any[]
  regions: any[]
  ticketingServices: any[]
}

const phoneMask = '###-###-####'
const ZIPCODE_MASK = 'A#A #A#'

export class LvcPartnerProfileModalContent extends MinzeElement {
  timezonesList: any = []
  culturalOrgTypesList: any = []
  reactive: Reactive = [
    ['organizationName', ''],
    ['role', ''],
    ['phone', ''],
    ['phoneExtension', ''],
    ['address1', ''],
    ['address2', ''],
    ['city', ''],
    ['province', ''],
    ['postalCode', ''],
    ['website', ''],
    ['timezones', [], false],
    ['culturalOrgTypes', [], false],
    ['disciplines', [], false],
    ['regions', [], false],
    ['role', ''],
    ['ticketingServices', [], false],
  ]

  errors: { [key: string]: string | boolean } = {}

  async onReady(): Promise<void> {
    // Data is hardcoded in the config files
    this.timezonesList = config.timezones
    this.culturalOrgTypesList = config.culturalOrganizationTypes
    // Load partner data if user is already authenticated
    await this.handleAuthChanged()
    this.rerender()
  }

  async savePartnerProfile() {
    const mainModule = MainModule.getInstance()

    const organizationName = this.getElementValue('#organizationName')
    const role = this.getElementValue('#role')
    const phone = this.getElementValue('#phone')
    const phoneExtension = this.getElementValue('#phoneExtension')
    const address1 = this.getElementValue('#address1')
    const address2 = this.getElementValue('#address2')
    const city = this.getElementValue('#city')
    const province = this.getElementValue('#province')
    const postalCode = this.getElementValue('#postalCode')
    const website = this.getElementValue('#website')
    const timezones = this.getJsonElementValue('[name="timezones"]')
    const culturalOrgTypes = this.getJsonElementValue('[name="cultOrgTypes"]')
    const disciplines = this.getJsonElementValue('[name="disciplines"]')
    const regions = this.getJsonElementValue('[name="regions"]')
    const ticketingServices = this.getJsonElementValue('[name="ticketingServices"]')

    this.resetErrors()

    this.validateField(
      organizationName,
      'organizationName',
      'partnerProfile.errors.organizationName'
    )
    this.validateField(address1, 'address1', 'partnerProfile.errors.address1')
    this.validateField(city, 'city', 'partnerProfile.errors.city')
    this.validateField(province, 'province', 'partnerProfile.errors.province')
    this.validateField(postalCode, 'postalCode', 'partnerProfile.errors.postalCode')
    this.validateField(role, 'role', 'partnerProfile.errors.role')
    this.validateArrayField(regions, 'regions', 'partnerProfile.errors.regions')
    this.validateArrayField(
      ticketingServices,
      'ticketingServices',
      'partnerProfile.errors.ticketingServices'
    )
    this.validateArrayField(timezones, 'timezones', 'partnerProfile.errors.timezones')
    this.validateArrayField(
      culturalOrgTypes,
      'culturalOrgTypes',
      'partnerProfile.errors.culturalOrgTypes'
    )
    this.validateArrayField(disciplines, 'disciplines', 'partnerProfile.errors.disciplines')

    if (postalCode.length < 7) {
      this.errors.postalCode = Locale.getKey('partnerProfile.errors.postalCode')
    }

    if (this.hasErrors()) {
      this.rerender()
      return
    }

    const partnerData: PartnerData = {
      organizationName,
      role,
      phone,
      phoneExtension,
      address1,
      address2,
      city,
      province,
      postalCode,
      website,
      timezones,
      culturalOrgTypes,
      disciplines,
      regions,
      ticketingServices,
    }

    await mainModule.getAuth().savePartnerData(partnerData)
    mainModule.showToastAlert(Locale.getKey('partnerProfile.successMessage'))
  }

  getElementValue(selector: string): string {
    const element: HTMLInputElement | null = this.select(selector)
    return unescapeHtml(element?.value || '')
  }

  getJsonElementValue(selector: string): any[] {
    const element: HTMLInputElement | null = this.select(selector)
    return element?.value ? JSON.parse(decodeURIComponent(element.value)) : []
  }

  resetErrors() {
    for (const key in this.errors) {
      this.errors[key] = false
    }
    this.rerender()
  }

  validateField(value: string, field: string, errorKey: string) {
    if (!value) {
      this.errors[field] = Locale.getKey(errorKey)
    }
  }

  validateArrayField(value: any[], field: string, errorKey: string) {
    if (value.length === 0) {
      this.errors[field] = Locale.getKey(errorKey)
    }
  }

  hasErrors(): boolean {
    return Object.values(this.errors).some(error => error)
  }

  async handleAuthChanged() {
    const mainModule = MainModule.getInstance()
    const partnerData = await mainModule.getAuth().getPartnerData()

    if (partnerData) {
      this.organizationName = partnerData.organizationName
      this.role = partnerData.role
      this.phone = partnerData.phone
      this.phoneExtension = partnerData.phoneExtension
      this.address1 = partnerData.address1
      this.address2 = partnerData.address2
      this.city = partnerData.city
      this.province = partnerData.province
      this.postalCode = partnerData.postalCode
      this.website = partnerData.website
      this.timezones = partnerData.timezones
      this.culturalOrgTypes = partnerData.culturalOrgTypes
      this.disciplines = partnerData.disciplines
      this.regions = partnerData.regions
      this.ticketingServices = partnerData.ticketingServices
    }
    this.rerender(true)
  }

  handleRegionsChange(event: any) {
    this.regions = event.detail
  }

  handleTicketingServicesChange(event: any) {
    this.ticketingServices = event.detail
  }

  html = () => `
  <div class="container">
    
    <lvc-box class="form" mt="8px">
      <lvc-text font-preset="small" color="#1E007D">${Locale.getKey('partnerProfile.description')}</lvc-text>
      <lvc-box mt="8px" textAlign="${window.matchMedia('(max-width: 730px)').matches ? 'left' : 'center'}"></lvc-box>
      
      <lvc-box mt="24px" display="flex" flexDirection="column" rowGap="16px">
        <lvc-input id="organizationName" default-value="${this.organizationName || ''}" value="${this.organizationName || ''}" placeholder="${Locale.getKey('partnerProfile.organizationNamePlaceholder')}"
        name="organizationName" label="${Locale.getKey('partnerProfile.organizationName')}" error="${this.errors.organization}"
        ></lvc-input>
        <lvc-input id="role" default-value="${this.role || ''}" value="${this.role || ''}" placeholder="${Locale.getKey('partnerProfile.rolePlaceholder')}"
        name="role" label="${Locale.getKey('partnerProfile.role')}" error="${this.errors.role}"
        ></lvc-input>
      </lvc-box>

      <lvc-box mt="32px" mb="32px">
        <lvc-text font-preset="medium" font-weight="bold">${Locale.getKey('partnerSignup.phone')}</lv-text>
        <hr />
        <div class="phone-container">
          </lvc-input>
          <lvc-input id="phone" default-value="${this.phone || ''}" value="${this.phone || ''}" placeholder="${Locale.getKey('partnerProfile.phonePlaceholder')}"
          name="phone" mask=${phoneMask} label="${Locale.getKey('partnerProfile.phone')}" error="${this.errors.phone}"
          >
          </lvc-input>
          <lvc-input default-value="${this.phoneExtension || ''}" value="${this.phoneExtension || ''}" id="phoneExtension" placeholder="${Locale.getKey('partnerSignup.phoneExtensionPlaceholder')}" 
          name="phoneExtension" error="${this.errors.phoneExtension}"mask="#####" label="${Locale.getKey('partnerSignup.phoneExtension')}">
          </lvc-input>
        </div>
      </lvc-box>

      <lvc-text font-preset="medium" font-weight="bold">${Locale.getKey('partnerProfile.organizationAddressTitle')}</lv-text>
      <hr />

      <div class="address-container">
        <lvc-box>
          <lvc-input id="address1" name="address1" default-value="${this.address1 || ''}" value="${this.address1 || ''}" placeholder="${Locale.getKey('partnerProfile.address1Placeholder')}"
          label="${Locale.getKey('partnerProfile.address1')}" error="${this.errors.address1}"
          ></lvc-input>
        </lvc-box>

        <lvc-box>
          <lvc-input id="address2" name="address2" default-value="${this.address2 || ''}" value="${this.address2 || ''}" placeholder="${Locale.getKey('partnerProfile.address2Placeholder')}"
          label="${Locale.getKey('partnerProfile.address2')}" error="${this.errors.address2}"
          ></lvc-input>
        </lvc-box>

        <lvc-box>
          <lvc-input id="city" name="city" default-value="${this.city || ''}" value="${this.city || ''}" placeholder="${Locale.getKey('partnerProfile.cityPlaceholder')}"
          label="${Locale.getKey('partnerProfile.city')}" error="${this.errors.city}"
          ></lvc-input>
        </lvc-box>

        <lvc-box>
          <lvc-input id="province" name="province" default-value="${this.province}" value="${this.province}" placeholder="${Locale.getKey('partnerProfile.provincePlaceholder')}"
          label="${Locale.getKey('partnerProfile.province')}" error="${this.errors.province}"
          ></lvc-input>
        </lvc-box>

        <lvc-box>
          <lvc-input id="postalCode" name="postalCode" mask="${ZIPCODE_MASK}" default-value="${this.postalCode || ''}" value="${this.postalCode || ''}" placeholder="${Locale.getKey('partnerProfile.postalCodePlaceholder')}"
          label="${Locale.getKey('partnerProfile.postalCode')}" error="${this.errors.postalCode}"
          ></lvc-input>
        </lvc-box>
      </div>


      <lvc-box mt="32px" mb="32px">
        <lvc-text font-preset="medium" font-weight="bold">${Locale.getKey('partnerProfile.generalInfoTitle')}</lv-text>
        <hr />

        <lvc-box mt="24px">
          <lvc-input id="website" name="website" default-value="${this.website || ''}" value="${this.website || ''}" placeholder="${Locale.getKey('partnerProfile.websitePlaceholder')}"
          label="${Locale.getKey('partnerProfile.website')}" error="${this.errors.website}"
          ></lvc-input>
        </lvc-box>

        <lvc-box mt="24px">
          <lvc-pro-space-select
          id="timezones"
          name="timezones"
          title="${Locale.getKey('partnerProfile.timezones')}"
          items="${encodeURIComponent(JSON.stringify(this.timezonesList))}"
          default-value="${encodeURIComponent(JSON.stringify(this.timezones)) || []}"
          background="white"
          error="${this.errors.timezones}"
          can-select-multiple="${false}"
          ></lvc-pro-space-select>
        </lvc-box>
      </lvc-box>

      <lvc-box mt="32px" name="organization-profile-container">
        <lvc-text font-preset="medium" font-weight="bold">${Locale.getKey('partnerProfile.organizationProfileTitle')}</lvc-text>
        <hr />

        <lvc-box mt="24px">
          <lvc-pro-space-select
          id="cultOrgTypes"
          name="cultOrgTypes"
          title="${Locale.getKey('partnerProfile.culturalOrganizationType')}"
          items="${encodeURIComponent(JSON.stringify(this.culturalOrgTypesList))}"
          default-value="${encodeURIComponent(JSON.stringify(this.culturalOrgTypes)) || []}"
          background="white"
          error="${this.errors.culturalOrgTypes}"
          can-select-multiple="${true}"
          ></lvc-pro-space-select>
        </lvc-box>

        <lvc-box mt="24px">
          <lvc-multiple-disciplines-field
          id="disciplines"
          name="disciplines"
          title="${Locale.getKey('partnerProfile.disciplines')}"
          items="${encodeURIComponent(JSON.stringify(this.disciplines))}"
          default-value="${encodeURIComponent(JSON.stringify(this.disciplines))}"
          background="white"
          error="${this.errors.disciplines}"
          ></lvc-multiple-disciplines-field>
        </lvc-box>

        <lvc-box mt="24px">
          <lvc-regions-field
          id="regions"
          name="regions"
          type="regions"
          chooseLabel="${Locale.getKey('partnerProfile.organizationRegionTitle')}"
          title="${Locale.getKey('partnerProfile.organizationRegionLabel')}"
          placeholder="${Locale.getKey('partnerProfile.organizationRegionSearch')}"
          label="${Locale.getKey('partnerProfile.organizationRegion')}"
          background="white"
          default-value="${encodeURIComponent(JSON.stringify(this.regions)) || []}"
          ></lvc-regions-field>
        </lvc-box>

        <lvc-box mt="24px">
          <lvc-ticketing-services-field
          id="ticketingServices"
          name="ticketingServices"
          type="ticketingServices"
          chooseLabel="${Locale.getKey('partnerProfile.ticketingServiceTitle')}"
          title="${Locale.getKey('partnerProfile.ticketingServiceLabel')}"
          placeholder="${Locale.getKey('partnerProfile.ticketingServiceSearch')}"
          label="${Locale.getKey('partnerProfile.ticketingServiceLabel')}"
          background="white"
          default-value="${encodeURIComponent(JSON.stringify(this.ticketingServices)) || []}"
          ></lvc-ticketing-services-field>
        </lvc-box>
    </lvc-box>

      <lvc-box mt="24px">
        <lvc-error error="${this.errors.general}"></lvc-error>
      </lvc-box>

      <lvc-box mt="24px" display="${window.matchMedia('(max-width: 730px)').matches ? 'block' : 'flex'}" width="100%" height="100%" justifyContent="center">
        <lvc-button enable-hover-box-shadow="true" width="${window.matchMedia('(max-width: 730px)').matches ? '100%' : 'fit-content'}" class="button" id="save-button" type="submit" height="100%" width="100%" font-size="1rem" font-weight="500" padding="14px 24px">
          ${Locale.getKey('partnerProfile.save')}
        </lvc-button>
      </lvc-box>
    </lvc-box>
  </div>
  `

  css = () => `
    :host {}

    a, a:visited {
      font-style: normal;
      font-weight: ${Font.weight.medium};
      font-size: 14px;
      text-decoration: none;
      color: #1E007D;
    }

    hr {
      border: 0;
      border-radius: 999px;
      height: 2px;
      background: rgba(30, 0, 125, 0.2);
      margin: 12px 0; 
    }

    .phone-container {
      margin-top: 12px;
      display: grid;
      grid-template-columns: 2fr 1fr;
      gap: 16px;
      align-items: end;
    }
    
    .address-container {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 16px; 
    }

    .address-container div {
      display: flex;
      flex-direction: column;
    }

    .container {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .save-container {
      margin-top: 40px;
    }

    .form {
      flex-grow: 4;
    }

    @media (max-width: 730px) {
      .phone-container {
        display: flex;
        flex-direction: column;
      }
  `

  eventListeners: EventListeners = [
    [window, 'lvc:user_state_changed', this.handleAuthChanged.bind(this)],
    ['#save-button', 'click', this.savePartnerProfile.bind(this)],
    ['lvc-regions-field', 'change', this.handleRegionsChange.bind(this)],
    ['lvc-ticketing-services-field', 'change', this.handleTicketingServicesChange.bind(this)],
  ]
}
